exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.xs-period-picker .xs-period-content {\n  border: 1px solid #c0c5cf;\n  border-radius: 5px;\n  display: inline-flex;\n  margin-bottom: 10px;\n}\n.xs-period-picker .xs-period-content .xs-period-year {\n  margin-right: 5px;\n}\n.xs-period-picker .xs-period-content .xs-period-year-input,\n.xs-period-picker .xs-period-content .xs-period-month-input {\n  margin-bottom: 0px;\n  border: 0;\n}\nlabel + .xs-period-content {\n  margin-top: 16px;\n}\n", ""]);

// exports
